/**
 * Controla la tabla de inspecciones.
 */
CamposExtraTextCtrl.$inject = ['$scope','$sce'];
export default function CamposExtraTextCtrl($scope,$sce) {

    var campExtText = this;
    campExtText.claseRow = issetAndNotEmpty(campExtText.claseRow) ? campExtText.claseRow == 'true' : true;
    var teniaValor = campExtText.campoExtra.valor !== null && campExtText.campoExtra.valor.length > 0;
    campExtText.hasError = false;

    campExtText.updateError = false;

    $scope.nombreHTML = $sce.trustAsHtml(campExtText.campoExtra.nombre);

    campExtText.validate = function () {
        if (campExtText.campoExtra.valor !== null && campExtText.campoExtra.valor.length > 0) {
            campExtText.hasError = false;

            campExtText.campoExtra.changed = true;
        } else if (teniaValor) {
            campExtText.hasError = true;
            campExtText.campoExtra.changed = false;
        }

    };

    campExtText.borrar = function () {
        campExtText.campoExtra.valor = null;
        campExtText.campoExtra.changed = true;
    };
}